import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LanguageService } from '@tsin-core/services/language.service';

/**
 * Returns a `CanActivateFn` that sets the active language before activating the route.
 * Usage in route definition:
 *   canActivate: [setLanguageGuard('fr')]
 */
export const setLanguageGuard = (lang: 'en' | 'fr'): CanActivateFn => {
  return () => {
    inject(LanguageService).set(lang);
    return true;
  };
};
